module.exports = __webpack_public_path__ + "img/save.19d5757.svg";